import { __decorate } from "tslib";
import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { WebClientService } from '../../services/webclient-settings.service';
import { WebsiteThemeService } from '../../services/website-theme.service';
import { DomSanitizer } from '@angular/platform-browser';
import { GoogleAnalyticsService } from '../../services/google-analytics.service';
let PopUpInfoComponent = class PopUpInfoComponent {
    constructor(router, webSettingsService, sanitizer, themeService, googleAnalyticsService) {
        this.router = router;
        this.webSettingsService = webSettingsService;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.googleAnalyticsService = googleAnalyticsService;
        this.mainColor = '';
        this.borderRadiusChoose = '';
        this.accentColor = '';
        this.showOnAllDevices = true;
        this.numberPerSession = 0;
        this.showCloseButton = true;
        this.showCookies = false;
        this.textColor = '';
        this.cookies = {};
        this.showCookieConsent = false;
        const numberPerSession = sessionStorage.getItem('pop_up_info_number_of_appearances');
        const parsedNumber = parseInt(numberPerSession);
        if (!isNaN(parsedNumber)) {
            this.numberPerSession = parsedNumber;
        }
        router.events.subscribe((val) => {
            if (val instanceof NavigationEnd) {
                const lang = localStorage.getItem('language');
                this.webSettingsService.getSettings().subscribe((data) => {
                    this.showCloseButton = this.webSettingsService.applySettings("POP_UP_INFO.CLOSE_BUTTON.VISIBLE");
                    const num = this.webSettingsService.getCustomValue('POP_UP_INFO.NUMBER_OF_APPEARANCES.VALUE');
                    this.numberOfAppearances = parseInt(num);
                    if (this.webSettingsService.applySettings('POP_UP_INFO.VISIBLE')) {
                        this.showOnAllDevices = this.webSettingsService.applySettings('POP_UP_INFO.SHOW_ON_ALL_DEVICES');
                        if (this.showOnAllDevices) {
                            this.toggle = (this.numberPerSession < this.numberOfAppearances) ? true : false;
                        }
                        else if (screen.width <= 640) {
                            this.toggle = false;
                        }
                        else {
                            this.toggle = (this.numberPerSession < this.numberOfAppearances) ? true : false;
                        }
                    }
                    const cookieVisible = this.webSettingsService.applySettings('COOKIE_CONSENT.VISIBLE');
                    this.showCookieConsentWindow(cookieVisible);
                });
            }
        });
        this.themeService.getTheme().subscribe((data) => {
            this.mainColor = this.themeService.getStyleAttribute('main_color');
            this.borderRadiusChoose = this.themeService.getStyleAttribute('border_radius_choose');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.textColor = this.themeService.getStyleAttribute('text_color');
        });
    }
    ngOnInit() {
    }
    get non_intrusive() {
        return (this.toggle === true) ? 'show' : 'hide';
    }
    dismiss() {
        this.numberPerSession++;
        sessionStorage.setItem('pop_up_info_number_of_appearances', this.numberPerSession + '');
        if (this.toggle) {
            this.toggle = false;
        }
    }
    closePopUp() {
        if (this.showCookieConsent) {
            this.showCookieConsent = false;
        }
    }
    getCookie(name) {
        const value = '; ' + document.cookie;
        const parts = value.split('; ' + name + '=');
        if (parts.length == 2) {
            return parts.pop().split(';').shift();
        }
    }
    setCookies(allCookies) {
        let necessaryCookies = ["cookieConsentZd", "cookieConsentEcd"];
        let marketingCookies = ['cookieConsentGa', 'cookieConsentHj', 'cookieConsentFb', 'cookieConsentAds', 'cookieConsentLn', 'cookieConsentQp'];
        if (allCookies == true) {
            var cookiesAll = necessaryCookies.concat(marketingCookies);
            cookiesAll.forEach((cookie) => {
                this.setCookie(cookie, '1');
            });
        }
        else {
            for (let [key, value] of Object.entries(this.cookies)) {
                if (value === true) {
                    this.setCookie(key, '1');
                    marketingCookies = marketingCookies.filter(item => item !== key);
                }
            }
            necessaryCookies.forEach((cookie) => {
                this.setCookie(cookie, '1');
            });
            marketingCookies.forEach((cookie) => {
                this.setCookie(cookie, '0');
            });
        }
        this.closePopUp();
        let array = [];
        array.push({
            'event': 'cookieConsentSet',
        });
        this.googleAnalyticsService.pushGAEvents(array);
    }
    setCookie(name, val) {
        const date = new Date();
        const value = val;
        date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));
        document.cookie = name + '=' + value + '; expires=' + date.toUTCString() + '; domain=.ecd.rs;path=/;SameSite=None; Secure';
    }
    showCookieConsentWindow(visible) {
        this.cookies.cookieConsentGa = true;
        if (this.getCookie('cookieConsentEcd')) {
            this.showCookieConsent = false;
        }
        else {
            if (visible) {
                this.showCookieConsent = true;
            }
        }
    }
};
PopUpInfoComponent.ctorParameters = () => [
    { type: Router },
    { type: WebClientService },
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: GoogleAnalyticsService }
];
PopUpInfoComponent = __decorate([
    Component({
        selector: 'ecd-pop-up-info',
        template: __importDefault(require("./pop-up-info.component.html")).default,
        animations: [
            trigger('popUpBottom', [
                state('show', style({
                    opacity: 1,
                    height: '*',
                })),
                state('hide, void', style({
                    opacity: 0,
                    height: 0,
                })),
                transition('hide => show', animate('1500ms')),
                transition('show => hide', animate('600ms'))
            ])
        ]
    })
], PopUpInfoComponent);
export { PopUpInfoComponent };
